import i18next from 'i18next';
import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { HydratedRouter } from 'react-router/dom';
import enLocale from '#marketing/locales/en.json';
import frLocale from '#marketing/locales/fr.json';
import zhLocale from '#marketing/locales/zh.json';
import { marketingLocaleFromHtmlLang } from '#marketing/lib/marketing-locale.js';

function initClientI18n() {
  const lng = marketingLocaleFromHtmlLang(document.documentElement.lang || 'en');
  i18next.use(initReactI18next).init({
    fallbackLng: 'en',
    lng,
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    resources: {
      en: { common: enLocale },
      fr: { common: frLocale },
      zh: { common: zhLocale },
    },
    react: { useSuspense: false },
  });
}

startTransition(() => {
  initClientI18n();
  hydrateRoot(
    document,
    <StrictMode>
      <I18nextProvider i18n={i18next}>
        <HydratedRouter />
      </I18nextProvider>
    </StrictMode>,
  );
});
